import { mergeAttributes, Node, type JSONContent } from "@tiptap/core"
import { md, nodePlainText } from "../../util/markdown-template"

export const LessonTitleContentExtension = Node.create({
  name: "lessonTitle",
  content: "text*",
  marks: "",

  // Before heading, so parseHTML gets to our rendered H1's first.
  priority: 200,

  renderHTML({ HTMLAttributes }) {
    return ["h1", mergeAttributes(HTMLAttributes, { "data-content-type": "lessonTitle" }), 0]
  },

  parseHTML() {
    return [
      {
        tag: 'h1[data-content-type="lessonTitle"]',
      },
    ]
  },

  renderMarkdown(node: JSONContent): string {
    return md`# ${nodePlainText(node)}`
  },
  // parseMarkdown happens in card-stack-markdown.ts instead of here.
})
